module.exports = __webpack_public_path__ + "img/tempuracaliforniagalerie.ec6ec706.jpg";